import { Shop } from "../../types/Shop";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

export const createShop = async (shop: Shop): Promise<string | void> => {
  if (!shop.id) {
    throw new Error("Community ID is required to create a shop");
  }

  const shopRef = firestore
    .collection(DB_PATH.COMMUNITY)
    .doc(shop.id)
    .collection("Shop")
    .doc("shop");

  console.log("Creating shop for community:", shop.id);

  // Remove the id from the payload since we're storing it at the document level
  const { id, ...payload } = shop;

  // Rethrow. A rejected write here is almost always a rules denial, and
  // swallowing it made the coach's edit vanish with a success message.
  try {
    await shopRef.set(payload, { merge: true });
    return shop.id;
  } catch (error) {
    console.error("Error creating shop", error);
    throw error;
  }
};
